<div *ngIf="(attendees$ | async)?.length > 0 || canEditAttendees; else noAttendees">
  <div *ngFor="let user of attendees$ | async" class="attendee-block">
    <div class="attendee-picture">
      <div
        class="profile-photo-container"
        [appTooltip]="'Declined event' | translate"
        [appTooltipDisabled]="!userDeclinedData[user._id]"
        appTooltipPlacement="top-center"
        [appTooltipArrow]="'bottom'"
      >
        <app-profile-photo [user]="user" width="32"></app-profile-photo>

        <!-- Decline X overlay -->
        <app-pencil-icon
          *ngIf="userDeclinedData[user._id]"
          class="decline-icon"
          name="cancel"
          type="material-icon"
        >
        </app-pencil-icon>
      </div>
    </div>
    <div class="user-name-block">
      <div class="user-name">
        <div class="name-block">
          <span>{{ user?.name || user.email }}</span>
          <span *ngIf="user._id === currentUser?._id"> {{ '(me)' | translate }}</span>
        </div>
      </div>
      <div class="user-subtitle" *ngIf="shouldShowSubtitle">
        <!-- Declined status indicator -->
        <ng-container *ngIf="userDeclinedData[user._id]">
          <div class="user-subtitle-declined">
            {{ 'Declined' | translate }}
          </div>
          <div class="user-subtitle-spacer">•</div>
        </ng-container>

        <div class="user-subtitle-role">
          <!-- Random edge case where the institution for *you* is an object, but for others it is a string -->
          {{
            currentUser?.institution &&
            user.institution &&
            (currentUser?.institution._id === user.institution ||
              currentUser?.institution._id === user.institution._id)
              ? (user.personas[0] | translate)
              : ('External User' | translate)
          }}
          <ng-container *ngIf="cohortUsersData.has(user._id)">
            {{ '(In Cohort)' | translate }}
          </ng-container>
        </div>

        <ng-container *ngIf="shouldShowEmail && user.name">
          <div class="user-subtitle-spacer">•</div>
          <div class="user-subtitle-email">
            {{ user.email }}
          </div>
        </ng-container>
      </div>
      <div class="decline-reason" *ngIf="userDeclinedData[user._id]?.reason">
        "{{ userDeclinedData[user._id].reason }}"
      </div>
    </div>
    <div class="attendee-options" *ngIf="canEditAttendees && !cohortUsersData.has(user._id)">
      <div class="remove" role="button" (click)="removeUser(user)">
        <i class="material-icons">close</i>
      </div>
    </div>

    <div class="attendance-status" *ngIf="showAttendance">
      <app-pencil-spinner
        [diameter]="18"
        [strokeWidth]="2"
        *ngIf="!eventAttendanceUsersMap[user._id]; else statusIndicator"
      >
      </app-pencil-spinner>
      <ng-template #statusIndicator>
        <app-attendance-status-indicator
          [attendanceUser]="eventAttendanceUsersMap[user._id]"
          [eventId]="currentEvent._id"
          [mode]="
            (user._id === currentUser?._id && !aclService.canModifyOwnAttendance(currentUser)) ||
            !canEditAttendance
              ? AttendanceStatusMode.VIEW_ONLY
              : AttendanceStatusMode.EDITABLE
          "
        ></app-attendance-status-indicator>
      </ng-template>
    </div>
    <div class="attendee-actions" *ngIf="isReassignAllowed && !userDeclinedData[user._id]">
      <app-pencil-button
        class="pencil-button event-attendee-actions-menu-trigger"
        data-name="event-attendee-actions-menu"
        icon="more_horiz"
        #eventAttendeeActionsMenuTrigger="matMenuTrigger"
        theme="icon"
        [matMenuTriggerFor]="eventAttendeeActionsMenu"
        [iconConfig]="{ type: 'mat-icon' }"
      >
      </app-pencil-button>
      <mat-menu
        #eventAttendeeActionsMenu
        [hasBackdrop]="true"
        class="pencil-mat-menu event-attendee-actions-menu single-item-menu light-scheme"
      >
        <app-pencil-menu-item
          icon="event_upcoming"
          [iconConfig]="{ type: 'svg-icon' }"
          data-name="event-attendee-actions-menu"
          [label]="'Reassign to another event' | translate"
          (clickEvent)="showReassignUserDialog(user._id)"
        >
        </app-pencil-menu-item>
      </mat-menu>
    </div>
  </div>
  <div class="add-attendee-in-progress-container" *ngIf="isInvitingUser">
    <div class="spinner-icon">
      <mat-spinner [diameter]="24" mode="indeterminate" strokeWidth="2"></mat-spinner>
    </div>
    <div class="name-block">{{ 'Adding to event...' | translate }}</div>
  </div>
  <div class="add-section" *ngIf="canEditAttendees && !isInvitingUser">
    <div class="add-attendee-container" [ngClass]="{ 'is-adding-user': isAddingUser }">
      <div class="add-attendee-main">
        <app-pencil-button
          *ngIf="!isAddingUser"
          class="pencil-button light flat-white"
          [attr.data-name]="invitedSectionTypeConfig.addButtonDataName"
          icon="add"
          [iconConfig]="{ type: 'mat-icon' }"
          [label]="invitedSectionTypeConfig.addButtonLabel"
          (clickEvent)="isAddingUser = true"
        ></app-pencil-button>
        <div class="attendee-search" *ngIf="isAddingUser">
          <div class="search-bar">
            <app-email-search
              #emailSearchComp
              [emails]="[]"
              [suggestUsers]="true"
              [placeholder]="'Search by name or email' | translate"
              [showParsedEmailChips]="false"
              (emitEmails)="handleEmailValues($event)"
              (emitUserselected)="selectUser($event)"
              (emitBlur)="handleInputBlur()"
            ></app-email-search>
          </div>
        </div>
      </div>
    </div>
    <ng-container *ngIf="invitedSectionTypeConfig.showFindButton">
      <span>{{ 'or' | translate }}</span>
      <div class="available-host-search">
        <app-pencil-button
          class="pencil-button light flat-white"
          [attr.data-name]="invitedSectionTypeConfig.findButtonDataName"
          icon="search"
          [iconConfig]="{ type: 'mat-icon' }"
          [label]="invitedSectionTypeConfig.findButtonLabel"
          (clickEvent)="showSelectAttendeeDialog.emit()"
        ></app-pencil-button>
      </div>
    </ng-container>
  </div>
</div>
<ng-template #noAttendees>
  <div *ngIf="!canEditAttendees" class="no-attendees-label">
    {{ 'No attendees added to this event' | translate }}
  </div>
</ng-template>
